module.exports = __webpack_public_path__ + "img/news17-0.a0e75ec2.png";